export enum CompensationHistoryTableHeaders {
  ReviewData = 'Review date',
  Base = 'Base',
  Bonus = 'Bonus',
  Total = 'Total',
  DifferenceCurrentTotalWithPrevious = '',
}
